export default "__VITE_ASSET__CF32Br3N__"